import { Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { Controller, useFormContext } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';

export const DatesStep = () => {
  const { control, setValue, watch } = useFormContext();

  const startDate = watch('startDate');
  const endDate = watch('endDate');
  const dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };

  return (
    <Form>
      <Container style={{ display: 'flex', justifyContent: 'center' }}>
        <Form.Group>
          <Controller
            control={control}
            name="dateRange"
            defaultValue={[null, null]}
            render={({ field }) => (
              <DatePicker
                wrapperClassName="datePicker"
                selectsRange
                dateFormat="MM/dd/yyyy"
                startDate={startDate}
                endDate={endDate}
                onChange={([start, end]) => {
                  setValue('startDate', start, { shouldValidate: true });
                  setValue('endDate', end, { shouldValidate: true });
                  field.onChange([start, end]);
                }}
                inline
                monthsShown={3}
                showMonthDropdown
              />
            )}
          />
        </Form.Group>
      </Container>

      <Row className="mt-3">
        <Col>
          <Form.Label>Start Date</Form.Label>
          <Form.Control
            value={startDate ? startDate.toLocaleDateString('en-US', dateOptions) : ''}
            readOnly
          />
        </Col>
        <Col>
          <Form.Label>End Date</Form.Label>
          <Form.Control
            value={endDate ? endDate.toLocaleDateString('en-US', dateOptions) : ''}
            readOnly
          />
        </Col>
      </Row>
    </Form>
  );
};
